export const normalizeString = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).trim();
};

export const dedupeSortedStrings = (values = []) =>
  [...new Set((values || []).map(normalizeString).filter(Boolean))].sort((a, b) =>
    a.localeCompare(b)
  );

export const normalizeTrainingRows = (rows = []) => {
  const map = new Map();

  (rows || []).forEach((row) => {
    const jobClassification = normalizeString(row?.jobClassification);
    if (!jobClassification) return;
    map.set(jobClassification, {
      jobClassification,
      requiredQuizIds: dedupeSortedStrings(row?.requiredQuizIds),
      requiredCategoryIds: dedupeSortedStrings(row?.requiredCategoryIds),
      source: normalizeString(row?.source),
      updatedAt: row?.updatedAt || null,
      updatedBy: normalizeString(row?.updatedBy),
    });
  });

  return [...map.values()].sort((a, b) => a.jobClassification.localeCompare(b.jobClassification));
};

export const normalizeJobCategoryRows = (rows = []) => {
  const map = new Map();

  (rows || []).forEach((row) => {
    const jobName = normalizeString(row?.jobName);
    if (!jobName) return;
    map.set(jobName, {
      jobName,
      requiredCategoryIds: dedupeSortedStrings(row?.requiredCategoryIds),
      source: normalizeString(row?.source),
      updatedAt: row?.updatedAt || null,
      updatedBy: normalizeString(row?.updatedBy),
    });
  });

  return [...map.values()].sort((a, b) => a.jobName.localeCompare(b.jobName));
};

const getFilenameFromHeaders = (headers, fallbackName) => {
  const raw = headers?.["content-disposition"] || headers?.["Content-Disposition"];
  if (!raw) return fallbackName;
  const match = /filename="?([^"]+)"?/i.exec(raw);
  return match && match[1] ? match[1] : fallbackName;
};

export const triggerDownloadFromResponse = (response, fallbackName) => {
  const blob = response?.data;
  if (!blob) return;

  const filename = getFilenameFromHeaders(response?.headers, fallbackName);
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(url);
};
